// theme.js
const THEME_KEY = "theme"; // "light" | "dark"

export function getSavedTheme() {
  return localStorage.getItem(THEME_KEY); // can be null
}

export function applyTheme(theme) {
  if (theme === "dark") {
    document.documentElement.dataset.theme = "dark";
  } else {
    delete document.documentElement.dataset.theme; // light = default
  }
}

export function setTheme(theme) {
  localStorage.setItem(THEME_KEY, theme);
  applyTheme(theme);
}

export function initTheme() {
  const saved = getSavedTheme();
  if (saved === "light" || saved === "dark") {
    applyTheme(saved);
    return saved;
  }

  // default: follow system preference
  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)")?.matches;
  const initial = prefersDark ? "dark" : "light";
  applyTheme(initial);
  return initial;
}